import { render, staticRenderFns } from "./commits.vue?vue&type=template&id=2a5e1a84&"
import script from "./commits.vue?vue&type=script&lang=js&"
export * from "./commits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports